/* eslint-disable
    func-names,
    max-len,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const factory = function (Transaction, Collection, LedgerCollection, $q, _, MainApi) {
  let TransactionCollection;
  return (TransactionCollection = (function () {
    TransactionCollection = class TransactionCollection extends Collection {
      static initClass() {
        this.prototype.$apiService = MainApi;
        this.prototype.$resource = 'document';
        this.prototype.$type = Transaction;
        this.prototype.$idName = '$id';
        this.prototype.$$cacheModels = true;

        this.prototype.$idSerializers = ['clientId'];
      }
      $url() {
        return `${super.$url()}/client/${this.clientId}/awaiting_category`;
      }

      $serialize(res) {
        return super.$serialize(
          res.map(transaction => Object.assign(transaction, { clientId: this.clientId })),
        );
      }

      $countNotes() {
        return this.data.filter(t => t.$hasResponse()).length;
      }

      $sortByNotes() {
        // order by date, then existence of notes / selectedLedger
        this.data = _(this.data)
          .sortBy(t => t.documentDate.getTime())
          .sortBy(t => !t.$hasResponse())
          .value();

        // find and return the index of the earliest transaction without notes
        const i = _.findIndex(this.data, t => !t.$hasResponse());
        if (i === -1) {
          return this.data.length;
        }
        return i;
      }

      static $getAwaiting(clientId) {
        const transactionCollection = new TransactionCollection({ clientId });
        const ledgers = new LedgerCollection(clientId);

        return ledgers.$promise.then(() => {
          const acrId = ledgers.$acrId();

          return transactionCollection.$fetch().then(() => {
            // set type of transaction to display on card
            const transactions = transactionCollection.data.map(transaction =>
              transaction.dataEntries.some(entry => entry.ledgerAccountId === acrId)
                ? transaction.$set({ type: 'revenue' })
                : transaction.$set({ type: 'expense' }),
            );
            return new TransactionCollection(`awaiting-${clientId}`, transactions);
          });
        });
      }
    };
    TransactionCollection.initClass();
    return TransactionCollection;
  })());
};

const moduleDeps = [
  require('data/collection/ledger').name,
  require('data/model/transaction').name,
  require('data/util').name,
];

module.exports = angular
  .module('bench.data.collection.transaction', moduleDeps)
  .factory('TransactionCollection', factory);
